// extracted by mini-css-extract-plugin
export default {"versionCardBody":"versionCardBody---jYRiM","changedRecordsList":"changedRecordsList---Y7g_0","changedRecord":"changedRecord---bUrUl"};